
module.exports = function () {
    const media = window.matchMedia('(max-width: 1023px)')
    const navbarHeight = $('header').outerHeight();
    let didScroll;
    let lastScrollTop = 0;
    let delta = 5;
    if (media.matches) {
        $(window).scroll(function (event) {
            didScroll = true;
        });

        setInterval(function () {
            if (didScroll) {
                hasScrolled();
                didScroll = false;
            }
        }, 250);

        function hasScrolled() {
            let st = $(this).scrollTop();

            if (Math.abs(lastScrollTop - st) <= delta)
                return;
            if (st > lastScrollTop && st > navbarHeight) {
                $('header').removeClass('nav-down').css("top", - navbarHeight);
            } else {
                if (st + $(window).height() < $(document).height()) {
                    $('header').removeClass('nav-up').css("top", '0');
                }
            }

            lastScrollTop = st;
        }
    }

};


